export const EVENT_HANDLED_NAV = `__eop__event__handled__`;
// TODO: Get core-js included to polyfill Symbol(); in IE11



// WEBPACK FOOTER //
// ./src/app/constants/events.ts